import React, { useState } from 'react';

import {
  AppBar,
  Avatar,
  Box,
  Divider,
  IconButton,
  Link,
  Popover,
  Stack,
  Toolbar,
  Typography,
} from '@mui/material';

import { Link as RouterLink } from 'react-router-dom';

import { useAuth } from '../utils/AuthContext';
import { useJiang } from '../utils/JiangContext';
import Notif from './notif';

export const LoginBtn = () => {
  const { logout, status, user } = useAuth();

  // console.log('user in loginbtn', user);

  let display_role = '';
  let display_role_color = '';
  let display_name = '';
  let avatar_name = '';
  if (user) {
    switch (user.role) {
      case 'memberY':
        display_role = '黃區會員'
        display_role_color = 'gold';
        break;
      case 'memberR':
        display_role = '紅區會員'
        display_role_color = 'red';
        break;
    }
    let is_chinese = /[\u4E00-\u9FFF]/.test(user.lastname);
    display_name = is_chinese ? `${user.lastname}${user.firstname}` : `${user.firstname} ${user.lastname}`;
    avatar_name = is_chinese ? user.lastname : user.firstname[0];
  }

  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  // const id = open ? 'simple-popover' : undefined;

  switch (status) {
    case 'logged_in': // fall through for somehow doesn't have user object
      if (user) {
        return (
          <>
            <IconButton size='small' onClick={handleClick}>
              <Avatar sx={{ width: 32, height: 32 }} src={user.picture || undefined}>
                {avatar_name}
              </Avatar>
            </IconButton>
            <Popover
              open={open}
              anchorEl={anchorEl}
              onClose={handleClose}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
            >
              <Stack
                sx={{ alignItems: 'center', margin: 4, mb: 3, width: 150 }}
                spacing={1}
              >
                <Avatar sx={{ width: 64, height: 64 }} src={user.picture || undefined}>
                  <Typography variant='body1' sx={{ fontSize: 32 }}>
                    {avatar_name}
                  </Typography>
                </Avatar>
                <Typography variant='h6' sx={{ fontWeight: 'bold' }}>{display_name}</Typography>
                <Typography variant='body1'>{user.email}</Typography>
                {user.org && <Typography variant='body1'>{user.org}</Typography>}
                <Typography variant='body1' sx={{ color: display_role_color, fontWeight: 'bold' }}>{display_role}</Typography>
                <Typography variant='body1'>會員ID: {user.unique_name}</Typography>
                <Divider />
                <Link sx={{ 'cursor': 'pointer' }} onClick={() => logout()}>登出</Link>
              </Stack>
            </Popover>
          </>
        )
      }
    // fallthrough
    case 'logged_out':
      return (
        <Link
          sx={{ cursor: 'pointer' }}
          to='/login'
          component={RouterLink}
        ><Typography variant='body2' textAlign='center'>登入</Typography></Link>
      )
    case 'loading':
      return <></>;
  }
};

const MainBar = () => {

  const { bigger_than_xs } = useJiang();

  return (
    <AppBar position='sticky' color='inherit'>
      <Toolbar
      disableGutters={!bigger_than_xs} 
      sx={{ display: 'flex', justifyContent: 'center', pl: 1.5, pr: 1.5 }}
      >
        <Box sx={{
          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          width: '100%', maxWidth: '2560px'
        }}>
          <Link to='/' component={RouterLink}>
            <Box
              component='img'
              src='/title.svg'
              sx={{ height: `${bigger_than_xs ? 25 : 22}px` }}
            />
          </Link>
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Notif />
            {bigger_than_xs && <Box sx={{ mr: 1 }} />} 
            <LoginBtn />
          </Box>
          {/* <Link><Typography variant='body1'>關於我們</Typography></Link> */}
        </Box>
      </Toolbar>
    </AppBar >
  )
}

export default MainBar;